if (!customElements.get('product-highlights')) {
  class ProductHighlights extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.openButton = this.querySelector('[data-ph-chart-open]');
      this.modal = this.querySelector('[data-ph-chart-modal]');
      this.closeButton = this.querySelector('[data-ph-chart-close]');
      this.abortController = new AbortController();

      this.openButton?.addEventListener('click', () => this.openModal(), {
        signal: this.abortController.signal,
      });

      this.closeButton?.addEventListener('click', () => this.closeModal(), {
        signal: this.abortController.signal,
      });

      this.modal?.addEventListener('click', (event) => {
        if (event.target === this.modal) this.closeModal();
      }, {
        signal: this.abortController.signal,
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.initialized = false;
    }

    openModal() {
      if (!this.modal) return;

      if (typeof this.modal.showModal === 'function') {
        this.modal.showModal();
      } else {
        this.modal.setAttribute('open', '');
      }
    }

    closeModal() {
      if (!this.modal) return;

      if (typeof this.modal.close === 'function') {
        this.modal.close();
      } else {
        this.modal.removeAttribute('open');
      }
    }
  }

  customElements.define('product-highlights', ProductHighlights);
}
